import { useEffect, useRef } from "react";
export function useExpandAllOnFirstRender(id, expandedRows, toggleAllRowsExpanded) {
    const dataLoaded = useRef(false);
    //If the grid is empty on the initial render, we want it to expand when data is first added.
    useEffect(() => {
        if (!dataLoaded.current && expandedRows.length > 0) {
            toggleAllRowsExpanded(true);
            dataLoaded.current = true;
        }
    }, [expandedRows, toggleAllRowsExpanded]);
    //Expand all rows each time the id changes
    useEffect(() => {
        toggleAllRowsExpanded(true);
    }, [id, toggleAllRowsExpanded]);
}
